import { API_ENDPOINTS } from '../utils/constants.js';

export const feedbackService = {
  // Submit feedback
  submitFeedback: async (feedbackData) => {
    const requestData = {
      name: feedbackData.name,
      email: feedbackData.email,
      subject: feedbackData.subject,
      message: feedbackData.message
    };
    try {
      const response = await fetch(
        API_ENDPOINTS.FEEDBACK,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData)
        }
      );
      // Parse the response as JSON regardless of status
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || 'Failed to submit feedback. Please try again later.');
      }
      return result;
    } catch (error) {
      throw new Error(error.message || 'Failed to submit feedback. Please try again later.');
    }
  }
};